import type { ReactElement } from 'react'
import styles from './InstagramMusicPicker.module.css'

export function AudioLinesPlayingIcon({
  isPlaying,
  className,
}: {
  isPlaying: boolean
  className?: string
}): ReactElement {
  return (
    <span className={className} aria-hidden>
      <svg
        className={styles.waveform}
        data-playing={isPlaying}
        fill="none"
        height={16}
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width={16}
      >
        <path d="M2 10v3" />
        <path d="M6 6v11" />
        <path d="M10 3v18" />
        <path d="M14 8v7" />
        <path d="M18 5v13" />
        <path d="M22 10v3" />
      </svg>
    </span>
  )
}
